import { useEffect } from "react";
import { useWallet } from "@solana/wallet-adapter-react";

import { useIdentity } from "../identity";
import { ConnectButton } from "./ConnectButton";

/**
 * Wallet slot UI. Renders our own pump.fun-styled <ConnectButton/> and, on
 * successful connect, calls attachWallet(pubkey) from useIdentity(). Wallet
 * connect is additive — never a gate for entering the lobby.
 */
export function WalletButton(): JSX.Element {
  const { publicKey, wallet } = useWallet();

  // useIdentity is Lane D's hook. Guard against it being undefined.
  const id = (typeof useIdentity === "function" ? useIdentity() : null) as
    | { attachWallet?: (pubkey: string, adapter: string) => void }
    | null;

  useEffect(() => {
    if (!publicKey) return;
    if (!id || typeof id.attachWallet !== "function") return;
    id.attachWallet(publicKey.toBase58(), wallet?.adapter.name ?? "");
  }, [publicKey, wallet, id]);

  return <ConnectButton />;
}
